export const lingxingApi = {
    get_warehouse: {
        method: 'post',
        api: 'backend/Lingxing/get_warehouse'
    },
    getSellerList: {
        method: 'post',
        api: 'backend/Lingxing/getSellerList'
    },
    save_store: {
        method: 'post',
        api: 'backend/Lingxing/save_store'
    },
  }